import axios from 'axios';
import React, { useState, useEffect } from 'react';
import Media from 'react-media';
import styled from 'styled-components';
import moment from '../../utils/MomentConst';

import { NotificationContainer, NotificationManager } from 'react-notifications';

import CardBG from '../../assets/CardBG.png';
import Discord from '../../assets/Discord.png';
import Cart from '../../assets/cart.png';
import Refresh from '../../assets/refresh.png';
import Dots from '../../assets/Dots.png';
import Edit from '../../assets/Edit.png';
import Unbind from '../../assets/Unbind.png';
import Welcome from '../../assets/Welcome.svg';
import Win from '../../assets/Win.png';
import { Flex, Text, Spinner } from '../../components';
import { Modal, ModalContainer, ModalButton, Input, Label } from "../Admin/components";
import { LicenseBoard, Navbar } from './sections';

import ReactTooltip from 'react-tooltip';

const Container = styled(Flex)`
  padding: 40px;
  background: #161930;
  border-radius: 8px;
`;

const WelcomeContainer = styled(Container)`
  background: url(${Welcome});
  background-size: cover;
  background-repeat: no-repeat;
`;

const PFP = styled.img`
  border-radius: 8px;
  width: 64px;
  height: 64px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
`;

const InvoiceCard = styled(Flex)`
  flex-direction: row;
  background: #161930;
  padding: 20px;
  @media only screen and (max-width: 700px) {
    flex-direction: column;
  }
`;

const CardContainer = styled(Flex)`
  width: 100%;
  background: #161930;
  border-radius: 10px;
`;

const Card = styled(Flex)`
  width: 100%;
  max-width: 330px;
  height: 200px;
  background-image: url(${CardBG});
  border-radius: 10px;
  padding: 20px 30px;
`;

const EditButton = styled.button`
  background: transparent;
  border: 0;
  outline: 0;
  transition: 0.2s ease;
  width: 100%;
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }
`;

const Button = styled.button`
  cursor: pointer;
  border-radius: 20px;
  padding: 8px;
  background: #202441;
  border: 0;
  outline: 0;
  transition: 0.2s ease;
  width: 100%;
  font-size: 12px;
  color: white;
  &:hover {
    opacity: 0.7;
  }
`;

const Link = styled.a`
  font-weight: 600;
  font-size: 10px;
  color: #7178b2;
`;


const Dashboard = ({ userData, login, isAdmin }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isGuildMember, setIsGuildMember] = useState(false);
  const [licenseData, setLicenseData] = useState(null);
  const [invoicesData, setInvoicesData] = useState(null);
  const [subscriptionsData, setSubscriptionsData] = useState(null);
  const [products, setProducts] = useState(null);
  const [licenseRevealed, setLicenseRevealed] = useState(false);
  const [cardData, setCardData] = useState(null);
  const [showInstancesPurchaseModal, setShowInstancesPurchaseModal] = useState(false);
  const [instancesPurchaseData, setInstancesPurchaseData] = useState(null);

  const openAdminPanel = () => {
    const hostname = window.location.hostname;
    if (hostname == 'localhost') {
      window.location.replace(`http://localhost:3000/admin/licenses`);
    } else {
      window.location.replace(`https://${window.location.hostname}/admin/licenses`);
    }
  };

  const [instancesPayload, setInstancesPayload] = useState({
    quantity: 0
  });

  useEffect(() => {

    if (userData) {

      axios
        .get('/api/dashboard/user/me')
        .then(res => {
          setLicenseData(res.data.licenseData);
          setIsGuildMember(res.data.isGuildMember);
          setInvoicesData(res.data.invoicesData);
          setSubscriptionsData(res.data.subscriptionsData);
          setProducts(res.data.products);
          setCardData(res.data.cardData);
          setInstancesPurchaseData(res.data.instancesPurchaseData);
          setIsLoading(false);
        })
        .catch(err => {
          login();
        });

    } else {
      login();
    }


  }, []);

  if (isLoading) return (
    <Spinner></Spinner>
  );

  const startSpinner = () => {
    setIsLoading(true);
  }

  const stopSpinner = () => {
    setIsLoading(false);
  }

  const renderCardData = () => {
    return (
      <Card dir="column">
        <Flex h="20%" />
        <Text.Body size="20" weight="600">
          {`${userData.username}#${userData.discriminator}`}
        </Text.Body>
        <Flex h="15%" />
        <Flex dir="row" w="100%" align="center">
          <img src={Dots} alt="****" />
          <Flex w="10px" />
          <img src={Dots} alt="****" />
          <Flex w="10px" />
          <img src={Dots} alt="****" />
          <Flex w="10px" />
          {cardData == null ? (
            <Text.Body size="20">N/A</Text.Body>
          ) : (
            <Text.Body size="20">{cardData.last4}</Text.Body>
          )}
        </Flex>
        <Flex h="10px" />
        <Text.Body size="10" style={{ opacity: 0.5 }}>
          Expiration
        </Text.Body>
        <Flex h="10px" />
        {cardData == null ? (
          <Text.Body size="16">N/A</Text.Body>
        ) : (
          <Text.Body size="16">{`${cardData.expMonth > 10 ? cardData.expMonth : '0' + cardData.expMonth}/${cardData.expYear}`}</Text.Body>
        )}
      </Card>
    );
  }

  const openCardManager = () => {
    setIsLoading(true);

    axios
      .get('/api/dashboard/user/portal')
      .then(res => {
        setIsLoading(false);
        window.location.replace(res.data.customerPortalURL)
      });

  }

  const requestDownload = (e) => {

    setIsLoading(true);

    axios
      .get(`/api/dashboard/user/request-download?os=${e.target.getAttribute('data-tid-os')}`)
      .then(res => {
        if (res.data.url) {
          setIsLoading(false);
          window.location.replace(res.data.url)
        }
      });

  }

  const renderDownloads = () => {
    if (licenseData.hasLicense) {
      return (
        <>
          <Flex h="20px" />
          <Flex dir="row" w="100%" >
            <Container
              dir="column"
              fg="1"
              align="center"
              justify="center"
            >
              <img src={Win} alt="" />
              <Flex h="20px" />
              <Text.Body center size="8" color="#7178B2">
                Download for Windows 32 bit
              </Text.Body>
              <Flex h="16px" />
              <Button data-tid-os='win' onClick={requestDownload}>Windows</Button>
            </Container>
            <Flex w="16px" />
          </Flex >
        </>
      );
    }
  }

  const joinDiscord = () => {

    axios
      .post('/api/dashboard/user/discord')
      .then(res => {
        setIsGuildMember(res.data.joined_server);
        NotificationManager.success('Joined Discord', '');
      })
      .catch(err => {
        console.error(err);
      });

  }

  const renderJoinDiscord = () => {
    if (!isGuildMember) {
      return (
        <>
          <img src={Discord} alt="" />
          <Flex w="10px" />
          <Text.Body size="12" color="#A4A1FF">
            Join Discord
          </Text.Body>
        </>
      );
    }
  }

  const updateLicenseData = (licenseData) => {
    setLicenseData(licenseData);
  }

  const renderPurchaseInstances = () => {
    if (instancesPurchaseData.instances_enabled) {
      return (
        <>
          <img src={Cart} alt="" />
          <Flex w="10px" />
          <Text.Body size="12" color="#23DE5B" onClick={() => setShowInstancesPurchaseModal(true)}>
            Purchase Instances
          </Text.Body>
        </>
      );
    }
  }

  const generateInstancesCheckout = () => {
    axios
      .get(`/api/dashboard/user/generate-instances-checkout/${instancesPayload.quantity}`)
      .then(res => {
        if (res.data.checkout_url) {
          location.href = res.data.checkout_url;
        }
      })
      .catch(err => {
        console.error(err);
      });
  }

  const unbindLicense = () => {

    axios
      .put('/api/dashboard/license/unbind')
      .then(res => {
        if (res.data.unbound) {
          setLicenseData({
            hasLicense: false,
            license: null,
            licenseType: null,
            licenseSubscription: {
              renewalDate: null
            }
          })
          alert(res.data.newKey);
        }
      })
      .catch(err => {
        console.error(err);
      });

  }

  const renderUnbindLicense = () => {
    if (licenseData.unbindData) {

      if (licenseData.unbindData.ok) {

        return (
          <>
            <Flex align="center" onClick={unbindLicense}>
              <img src={Unbind} alt="" />
              <Flex w="10px" />
              <Text.Body size="12" color="#FF5071">
                Unbind Key
              </Text.Body>
            </Flex>
          </>
        );

      } else {

        let naReason = "";

        if (!licenseData.unbindData.delayOk) {
          naReason += "- Active Bind Cooldown Delay";
        }

        if (!licenseData.unbindData.subscriptionOk) {
          if (naReason.length > 0) {
            naReason += "<br />";
          }
          naReason += "- Subscription Renewal is imminent"
        }

        if (!licenseData.unbindData.typeOk) {
          if (naReason.length > 0) {
            naReason += "<br />";
          }
          naReason += "- Key Type does not allow it"
        }

        if (licenseData.license.force_no_unbind) {
          if (naReason.length > 0) {
            naReason += "<br />";
          }
          naReason += "- Admin Locked"
        }

        return (
          <>
            <Flex align="center">
              <Flex w="10px" />
              <Text.Body size="12" data-tip={naReason} color="#FFCA59">
                Unbind N/A
              </Text.Body>
            </Flex>
          </>
        );

      }

    }
  }

  const toggleAutoRenew = () => {
    if (confirm(`${subscriptionsData.isAutoRenewing ? 'Are you sure you want to DISABLE automaticaly renew your license(s) renewal' : 'Are you sure you want to ENABLE automaticaly renew your license(s) renewal' } `)) {
      axios
        .put(`/api/dashboard/user/toggle-auto-renewing`)
        .then(res => {
          setSubscriptionsData({
            ...subscriptionsData,
            isAutoRenewing: res.data.is_auto_renewing
          })
        })
        .catch(err => {
          console.error(err);
        });
    }
  }

  const renderToggleAutoRenew = () => {
    return (
      <>
        <img src={Refresh} alt="" />
        <Flex w="10px" />
        <Text.Body size="12" color="#EC3EFD">
          Toggle Auto Renew
        </Text.Body>
      </>
    );
  }

  const renderLicenseActions = () => {
    if (licenseData.hasLicense) {
      return (
        <>
          <Flex h="30px" />
          <Flex dir="row" w="100%">
            <Flex dir="column" fg="1" align="center" justify="center">
              <Flex h="10px" />
              <Button style={{ padding: 0, background: 'transparent' }}>
                {renderUnbindLicense()}
              </Button>
              <Flex h="24px" />
              <Button style={{ padding: 0, background: 'transparent' }}>
                <Flex align="center">
                  {renderPurchaseInstances()}
                </Flex>
              </Button>
              <Button style={{ padding: 0, background: 'transparent' }}>
                <Flex align="center" onClick={joinDiscord}>
                  {renderJoinDiscord()}
                </Flex>
              </Button>
              <Button style={{ padding: 0, background: 'transparent' }}>
                <Flex align="center" onClick={toggleAutoRenew}>
                  {renderToggleAutoRenew()}
                </Flex>
              </Button>
            </Flex>
            <Flex w="16px" />
            <Container dir="column" fg="1" style={{ padding: 20 }}>
              <Link href="/">Documentation</Link>
              <Flex h="10px" />
              <Link href="/terms">Terms of Service</Link>
              <Flex h="10px" />
              <Link href="/privacy">Privacy Policy</Link>
              <Flex h="10px" />
              <Link
                style={{ color: '#33C4FF' }}
                href="mailto:contact@trickle.bot"
              >
                contact@trickle.bot
              </Link>
            </Container>
          </Flex>
          <Flex h="20px" />
        </>
      );
    }
  }

  const renderInvoices = () => {
    if (invoicesData.hasInvoices) {

      const invoices = [];

      for (const [index, value] of invoicesData.invoices.entries()) {
        if (value.status == 'draft') {
          continue;
        }
        let filter = products.filter((product) => product.id == value.lines.data[0].price.product);
        let product_name = filter.length > 0 ? filter[0].name : value.description;

        invoices.push(
          <Grid>
            <InvoiceCard onClick={() => {
              if (value.hosted_invoice_url) {
                window.open(value.hosted_invoice_url)
              }
            }}>
              <Text.Body size="12" color="#7178B2">
                #: {index + 1}
              </Text.Body>
              <Flex fg="1" w="8px" h="8px" />
              <Text.Body size="12">
                {`Product: ${product_name}`}
              </Text.Body>
              <Flex fg="1" w="8px" h="8px" />
              <Text.Body size="12" color="#7178B2">
                Price: ${value.amount_due / 100}
              </Text.Body>
              <Flex fg="1" w="8px" h="8px" />
              <Text.Body size="12" color="#7178B2">
                Due : {moment.unix(value.period_end).format('MMMM D, YYYY')}
              </Text.Body>
              <Flex fg="1" w="8px" h="8px" />
              <Text.Body size="12" color="#7178B2" style={{ width: 200 }}>
                Status:&nbsp;
                {renderInvoiceStatus(value)}
              </Text.Body>
              <Flex fg="1" />
            </InvoiceCard>
          </Grid>

        )
      }

      return (
        <>
          <Text.Heading size="18">Invoices</Text.Heading>
          <Flex h="16px" />
          {invoices}
        </>
      );
    }
  }

  const renderMembershipStatus = () => {
    if (subscriptionsData.hasSubscription) {
      return (
        <span style={{ color: '#60FFB0' }}>
          <b>Active</b>
        </span>
      );
    } else {
      return (
        <span style={{ color: '#FF607D' }}>
          <b>Inactive</b>
        </span>
      );
    }
  }

  const renderAutoRenewStatus = () => {
    if (subscriptionsData.isAutoRenewing) {
      return (
        <span style={{ color: '#60FFB0' }}>
          <b>Active</b>
        </span>
      );
    } else {
      return (
        <span style={{ color: '#FF607D' }}>
          <b>Inactive</b>
        </span>
      );
    }
  }

  const renderAdminPanel = () => {
    if (isAdmin) {
      return (
        <span>
          <Button onClick={openAdminPanel}>Admin Dashboard</Button>
        </span>
      );
    }
  }

  const renderInvoiceStatus = (invoice) => {

    switch (invoice.status) {
      case 'paid':
        return (
          <span style={{ color: '#60FFB0', fontWeight: 700 }}>
            {invoice.status.charAt(0).toUpperCase() + invoice.status.slice(1)}
          </span>
        );
        break;
      case 'uncollectible':
        return (
          <span style={{ color: '#FF607D', fontWeight: 700 }}>
            {invoice.status.charAt(0).toUpperCase() + invoice.status.slice(1)}
          </span>
        );
        break;
      case 'void':
        return (
          <span style={{ color: '#FF607D', fontWeight: 700 }}>
            {invoice.status.charAt(0).toUpperCase() + invoice.status.slice(1)}
          </span>
        );
        break;
      default:
        return (
          <span style={{ color: '#FFCA59', fontWeight: 700 }}>
            {invoice.status.charAt(0).toUpperCase() + invoice.status.slice(1)}
          </span>
        );
        break;
    }

  }

  return (
    <>
      <Media query={{ minWidth: 710 }}>
        {matches => (
          <>
            <Navbar />
            <Flex dir={matches ? 'row' : 'column'} w="100%">
              <Flex dir="column" fg="2" w={matches ? 'unset' : '100%'}>
                <WelcomeContainer w="100%">
                  <Flex dir="row" align="center">
                    <PFP
                      src={userData.avatar}
                      alt=""
                    />
                    <Flex w="24px" />
                    <Flex dir="column" h="100%">
                      <Flex fg="1" />
                      <Text.Body>
                        Welcome back, <b>{userData.username}</b>
                      </Text.Body>
                      <Flex fg="2" />
                      <Text.Body color="#7178B2">
                        Membership Status:&nbsp;
                        {renderMembershipStatus()}
                      </Text.Body>
                      <Text.Body color="#7178B2">
                        Auto Renew Status:&nbsp;
                        {renderAutoRenewStatus()}
                      </Text.Body>
                      <Text.Body color="#7178B2">
                        Instances Count:&nbsp;
                        {
                          licenseData.hasLicense ?
                            licenseData.license.instances == -1 ? 'Unlimited' : licenseData.license.instances
                            :
                            0
                        }
                      </Text.Body>
                      {renderAdminPanel()}
                      <Flex fg="1" />
                    </Flex>
                  </Flex>
                </WelcomeContainer>
                <Flex h="30px" />
                <LicenseBoard hasLicense={licenseData.hasLicense} licenseData={licenseData} onLicenseSubmit={updateLicenseData} startSpinner={startSpinner} stopSpinner={stopSpinner} licenseRevealed={licenseRevealed} updateLicenseReveal={setLicenseRevealed} ></LicenseBoard>
                <Flex h="30px" />
                {renderInvoices()}
              </Flex>
              <Flex w="40px" h="40px" />
              <Flex dir="column" w="330px" mw="300px">
                <CardContainer dir="column">
                  {renderCardData()}
                  <EditButton onClick={openCardManager}>
                    <Flex h="50px" align="center" justify="center" w="100%">
                      <img src={Edit} alt="" />
                      <Flex w="10px" />
                      <Text.Body weight="600" color="#CA7AFF">
                        Update Card Info
                      </Text.Body>
                    </Flex>
                  </EditButton>
                </CardContainer>
                {renderDownloads()}
                {renderLicenseActions()}
              </Flex>
            </Flex>
          </>
        )}
      </Media>

      {showInstancesPurchaseModal &&
        <ModalContainer>
          <Modal dir="column">
            <Text.Heading size="18">Create your checkout</Text.Heading>
            <Flex h="24px" />
            <Label>How many instances would you like to purchase ?</Label>
            <Flex h="24px" />
            <Input
              type="number"
              defaultValue="0"
              min="0"
              onChange={(e) => {
                setInstancesPayload({
                  ...instancesPayload,
                  quantity: e.target.value
                })
              }}
            />
            <Flex h="24px" />
            <Label>Total : ${instancesPayload.quantity * instancesPurchaseData.instances_price}</Label>
            <Flex h="24px" />
            <Flex dir="row" w="100%">
              <ModalButton onClick={() => setShowInstancesPurchaseModal(false)} bg="#202441">Cancel</ModalButton>
              <Flex w="16px" />
              <ModalButton bg="#F32FE0" onClick={() => generateInstancesCheckout()}>Go to Checkout</ModalButton>
            </Flex>
          </Modal>
        </ModalContainer>
      }

      <NotificationContainer />
      <ReactTooltip multiline={true} />
    </>
  );
};

export default Dashboard;
